import React from 'react'
import { ScaleLinear } from 'd3-scale'
import { nF } from 'components/Charts_Assets'

import './styles.scss'
export const Value = ({
  value,
  x,
  y,
  circle = false,
  offset = 0,
  textAnchor = 'middle',
  line = false,
  unit,
}: {
  value: number
  x: number
  y: ScaleLinear<number, number>
  circle?: boolean
  offset?: number
  textAnchor?: 'middle' | 'start' | 'end'
  line: boolean
  unit?: string
}) => {
  let lastVal = {
    x: x,
    y: y.range()[0] - y(value) - offset,
    text:
      value > 100
        ? Math.round(value - 100).toString()
        : -Math.round(100 - value).toString(),
  }
  return (
    <g className='Value'>
      <text x={lastVal.x + 5} y={lastVal.y + 5} textAnchor={textAnchor}>
        {lastVal.text > 0
          ? '+' + nF(+lastVal.text) + (unit ? unit : '')
          : nF(+lastVal.text) + (unit ? unit : '')}
      </text>
      {line && (
        <line
          x1={lastVal.x}
          x2={lastVal.x}
          y1={lastVal.y + 4}
          y2={lastVal.y + offset - 4}
        />
      )}
      {circle && <circle cx={lastVal.x} cy={lastVal.y + offset} r={3} />}
    </g>
  )
}
